import { canonicalCategoryName } from './resolveRoofCombinationsForRunAi';

/** Parse Gemini `RECOMMENDED_ROOF_COMBINATIONS` line into named roof subsets. */
export function parseRoofCombinationsFromAi(
    aiResultText: string,
    validRoofIds: Set<string>,
): { name: string; roofFaceIds: string[] }[] {
    const text = (aiResultText || '').trim();
    if (!text) return [];
    const match = text.match(/RECOMMENDED_ROOF_COMBINATIONS:\s*([^\n]+)/i);
    if (!match) return [];

    const combinations: { name: string; roofFaceIds: string[] }[] = [];
    const seenNames = new Set<string>();

    match[1].split(';').forEach((part: string) => {
        const trimmed = part.trim();
        if (!trimmed) return;
        const pipeIdx = trimmed.indexOf('|');
        const rawName = pipeIdx >= 0 ? trimmed.slice(0, pipeIdx).trim() : trimmed;
        const idsStr = pipeIdx >= 0 ? trimmed.slice(pipeIdx + 1) : '';
        const roofFaceIds = idsStr
            .split(',')
            .map((s: string) => s.trim())
            .filter((id: string) => validRoofIds.has(id));
        const name = canonicalCategoryName(rawName);
        if (name && roofFaceIds.length > 0 && !seenNames.has(name)) {
            seenNames.add(name);
            combinations.push({ name, roofFaceIds });
        }
    });
    return combinations;
}